import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DialogService } from 'src/app/services/dialog.service';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';

@Component({
    selector: 'meli-product-relation',
    templateUrl: './meli-product-relation.component.html',
    styleUrls: ['./meli-product-relation.component.scss'],
    standalone: false
})
export class MeliProductRelationComponent implements OnInit {

  itemselected = false;
  produto:string = "";
  @Input()melidata:Object;
  @Input()variation:{id:string, codeproduct:string}[] = [];

  formInicial:UntypedFormGroup;
  constructor(private form:UntypedFormBuilder, private dialogServices:DialogService, private dynaServices:DynamicFormsService) { 
    this.formInicial = form.group(
      {
        "CODEPRODUCT":"",
        "NAME":""
      }
      );

  }

  ngOnInit(): void {
  }



  importar(event:Event){
    event.stopPropagation();
    event.preventDefault();
    let columnDef:columnsDef = {
        COLUMNNAME: 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
        COLUMNDESC: 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
        DATATYPE: 'VARCHAR',
        IDCOLUMN: 1,
        ISIDENTITY: 0,
        ISPK: 1,
        VISIBLE: 1,
        PLACEHOLDER: 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
        ISREQUIRED:0,
        LINE:0,
        CELL:0,
        tab:''
    }


    this.dialogServices.openFindDialog('Mktpproducts','Cadastro de Produtos',this.dynaServices,this.formInicial,columnDef,(data)=>{
        this.itemselected = true;
        this.produto = data['CODEPRODUCT']  + " - " + data['FK_MKTPMELI_MKTPPRODUCTS->NAME'];
        this.melidata['CODEPRODUCT'] = data['CODEPRODUCT'];

        if ( this.variation.find(x=>x.id == this.melidata['id'] ) != null ){
          this.variation.find(x=>x.id == this.melidata['id'] ).codeproduct = data['CODEPRODUCT'];
        }else{
          this.variation.push({id:this.melidata['id'], codeproduct:data['CODEPRODUCT']});
        }
        
    });
  }

}
